<!-- will work when only heading and value is provided -->
<div *ngIf="!isContextMenu" class="dropdown-option {{customClass}}" [class.disabled]="isDisabled"
     [class.dropdown-option--selected]="selected" (click)="selectOption()">
     <span *ngIf="icon"><i class="drop-down-icon" [ngClass]="icon"></i></span>
     <span *ngIf="!isStatus" [appEllipsisTooltip]="heading" [tooltipIsDisabled]="disableEllipsisTooltip">{{heading}}</span>
  <span *ngIf="isStatus"><app-status  [status]="heading"></app-status></span>
</div>
<!-- will work when there is count , icon and other details other than heading -->
<div *ngIf="isContextMenu && !item" class="dropdown-option" [class.disabled]="isDisabled"
  [class.dropdown-option--selected]="selected" (click)="selectOption()">
<ng-content></ng-content>
<span *ngIf="heading" [appEllipsisTooltip]="heading">{{heading}}</span>
<span *ngIf="count">{{count}}</span>
</div>
<!-- will work if there any checkbox and radio button -->
<div *ngIf="isContextMenu && item" class="dropdown-option" [class.disabled]="isDisabled"
  [class.dropdown-option--selected]="selected" >
  <app-checkbox   [theme]="Blue_Theme" [value]="item.selected" [label]="item.value" (stateChanged)="checkboxSelect($event)" ></app-checkbox>
</div>

